(function() {
    angular.module('ngmvac').directive('bsDatepickerDos', BSDatePickerHotel);

    function BSDatePickerHotel() {
        var states = {
            checkInMovilHotel: false,
            checkOutMovilHotel: false
        }

        return {
            link: fnLinkDos,
            controller: ['$scope', function(scope) {
            	scope.clase = (scope.step == 2) ? '' : 'col-md-'+scope.colNumber+' col-xs-'+scope.colNumber;
            	scope.mtClass = (scope.step == 1) ? '' : 'mt15';
                // scope.showIcon = (scope.modulo == 'lista-hoteles' && scope.display == 'inline') ? false : true;
                scope.showIcon = false;
                scope.label = 'lbindexcot';
                scope.lbmovil = 'labelmovil';
                if(scope.modulo == 'lista-hoteles' && scope.display == 'block'){
                    scope.showIcon = true;
                    scope.label = 'lblistacot';
                    scope.lbmovil = 'lblistahoteles';
                }

                scope.coldate = 'row';
                scope.margin = 'mt10';
                scope.hidepadd = '';
                scope.borrarpad = '';
            
                if(scope.detalles == 'true'){
                    scope.borrarpad = 'delpadd borderPickerDet ';
                    scope.coldate = 'col-md-12 col-xs-12';
                    scope.margin = '';
                    scope.hidepadd = 'mthide10'
                    scope.inlinedet = 'inlinedetalles';
                }
            }],
            scope: {
                checkOutLabelHotel: '@',
                checkInLabelHotel: '@',
                step: '@',
                initialCheckInHotel: '=',
                initialCheckOutHotel: '=', 
                colNumber: '@',
                display:'<',
                modulo: '<',
                detalles: '@'
            },
            templateUrl: window.location.origin+'/components/fechas_hotel'
        }

        function fnLinkDos(scope, element, attrs) {
            var startDate = "+2d";

            var startDateCheckInInput = moment().add(4 ,'days').format('YYYY-MM-DD');
            var startDateCheckOutInput = moment().add(5 ,'days').format('YYYY-MM-DD');


            $('#checkInHotel').val( startDateCheckInInput );
			$('#checkOutHotel').val( startDateCheckOutInput );
            $('#checkInFieldHotel').val( startDateCheckInInput );
            $('#checkOutFieldHotel').val( startDateCheckOutInput );

            var endDate = moment(startDateCheckInInput).add(29, 'days').format('YYYY-MM-DD');

            $(".checkInHotel").datepicker({
                format: "yyyy-mm-dd",
                todayBtn: "linked",
                language: 'es',
                startDate: startDate,
                orientation: "auto"
            }).on('changeDate', function(e){
                $('#checkInFieldHotel').val(e.format('yyyy-mm-dd'));
            });

            $(".checkOutHotel").datepicker({
                format: "yyyy-mm-dd",
                todayBtn: "linked",
                language: 'es',
                startDate: startDate, 
                orientation: "auto"
            }).on('changeDate', function(e){
                $('#checkOutFieldHotel').val(e.format('yyyy-mm-dd'));
            }).on('show', function(e) {
                let datepicker = $(this).data('datepicker')
                let datepickerElement = datepicker.picker;
                $(datepickerElement).on('mouseover', 'td.day', function (e) {
                    let index = 0;
                    $('.datepicker-days .table-condensed').find('tbody').find('tr').each(function (rowIndex) {
                        let current;
                        $(this).find('td').each(function (idx) {
                            index ++;
                            $(this).attr('data-index', index);
                            current = $(this).attr('data-index');
                            let start = $('td').first().attr('data-index');
                            let end = $(e.target).attr('data-index');
                            if ((current - start) * (current - end) <= 0) {
                                if(!$(this).hasClass('disabled')){
                                    $(this).addClass('range');
                                }
                            } else {
                                $(this).removeClass('range');
                            }  
                            if ( end == current  ){
                                $(e.target).removeClass('range').addClass('selected range-end');
                            } else {
                                $(this).removeClass('selected range-end');
                            }                        
                        });
                    });
                    
                });
            });

            $(".checkOutHotel").datepicker("setStartDate", moment(startDateCheckInInput).add(1, 'days').format("YYYY-MM-DD"));
            $(".checkOutHotel").datepicker('update', moment(startDateCheckInInput).add(2, 'days').format("YYYY-MM-DD"));
            $(".checkOutHotel").datepicker('setEndDate', endDate);

            scope.$watch('initialCheckInHotel', function(newCheckIn) {
            	
            	$('.checkInHotel').datepicker('update', newCheckIn);
            	$(".checkOutHotel").datepicker("setStartDate", moment(newCheckIn).add(1, 'days').format("YYYY-MM-DD"));
	            $(".checkOutHotel").datepicker('update', moment(newCheckIn).add(2, 'days').format("YYYY-MM-DD"));
	            $(".checkOutHotel").datepicker('setEndDate', moment(newCheckIn).add(29, 'days').format('YYYY-MM-DD'));
            	scope.checkInHotel = newCheckIn;

            });

            scope.$watch('initialCheckOutHotel', function(newCheckOut) {
            	$('.checkOutHotel').datepicker('update', newCheckOut);
            	scope.checkOutHotel = newCheckOut;
            });
            $('#checkInHotel').on('click', function(e) {
                let addRange = false;
                $('.datepicker-days .table-condensed').find('tbody').find('tr').each(function (rowIndex) {
                    $(this).find('td').each(function (idx) {
                        $(this).removeClass('active');
                        if(moment(new Date(Number($(this).attr('data-date')))).add(1, 'days').format('YYYY-MM-DD') === scope.checkInHotel){
                            $(this).addClass('active');
                            addRange = true;
                        }
                        if(moment(new Date(Number($(this).attr('data-date')))).add(1, 'days').format('YYYY-MM-DD') === scope.checkOutHotel){
                            $(this).addClass('active');
                            addRange = false;
                        }
                        if(addRange) {
                            $(this).addClass('range');
                        }
                    });
                });
            });

            $('#checkOutHotel').on('click', function(e) {
                let addRange = false;
                $('.datepicker-days .table-condensed').find('tbody').find('tr').each(function (rowIndex) {
                    $(this).find('td').each(function (idx) {
                        $(this).removeClass('active');
                        if(moment(new Date(Number($(this).attr('data-date')))).add(1, 'days').format('YYYY-MM-DD') === scope.checkInHotel){
                            $(this).addClass('active');
                            addRange = true;
                        }
                        if(moment(new Date(Number($(this).attr('data-date')))).add(1, 'days').format('YYYY-MM-DD') === scope.checkOutHotel){
                            $(this).addClass('active');
                            addRange = false;
                        }
                        if(addRange) {
                            $(this).addClass('range');
                        }
                    });
                });
            });

            $('#checkInMovilHotel').on('click', function(e) {
            	if (states.checkInMovil) {
                    $('.checkInHotel').datepicker('hide');
                    states.checkInMovil = false;
                } else {
                    $('.checkInHotel').datepicker('show');
                    $('html,body').animate({scrollTop: $('#checkInMovilHotel').offset().top - 100});
                  	$('#checkInMovilHotel').addClass('datepicker-input-content-selected');
                    $('.datepicker').css({
                    	top: $('#checkInMovilHotel').offset().top + $('#checkInMovilHotel').height() + 10
                    });

                    states.checkInMovilHotel = true;
                    if (states.checkOutMovilHotel) states.checkOutMovilHotel = false;
                }
                let addRange = false;
                $('.datepicker-days .table-condensed').find('tbody').find('tr').each(function (rowIndex) {
                    $(this).find('td').each(function (idx) {
                        $(this).removeClass('active');
                        if(moment(new Date(Number($(this).attr('data-date')))).add(1, 'days').format('YYYY-MM-DD') === scope.checkInHotel){
                            $(this).addClass('active');
                            addRange = true;
                        }
                        if(moment(new Date(Number($(this).attr('data-date')))).add(1, 'days').format('YYYY-MM-DD') === scope.checkOutHotel){
                            $(this).addClass('active');
                            addRange = false;
                        }
                        if(addRange) {
                            $(this).addClass('range');
                        }
                    });
                });
            });

            $('#checkOutMovilHotel').on('click', function(e) {
                if (states.checkOutMovilHotel) {
                    $('.checkOutHotel').datepicker('hide');
                    states.checkOutMovilHotel = false;
                } else {
                    $(".checkOutHotel").datepicker('show');
                    $('html,body').animate({scrollTop: $('#checkOutMovilHotel').offset().top - 100});
                    $('#checkOutMovilHotel').addClass('datepicker-input-content-selected');
                    $('.datepicker').css({
                    	top: $('#checkOutMovilHotel').offset().top + $('#checkOutMovilHotel').height() + 10
                    })

                    states.checkOutMovilHotel = true;
                    if (states.checkInMovilHotel) states.checkInMovilHotel = false;
                }
                let addRange = false;
                $('.datepicker-days .table-condensed').find('tbody').find('tr').each(function (rowIndex) {
                    $(this).find('td').each(function (idx) {
                        $(this).removeClass('active');
                        if(moment(new Date(Number($(this).attr('data-date')))).add(1, 'days').format('YYYY-MM-DD') === scope.checkInHotel){
                            $(this).addClass('active');
                            addRange = true;
                        }
                        if(moment(new Date(Number($(this).attr('data-date')))).add(1, 'days').format('YYYY-MM-DD') === scope.checkOutHotel){
                            $(this).addClass('active');
                            addRange = false;
                        }
                        if(addRange) {
                            $(this).addClass('range');
                        }
                    });
                });
            });

            $(element).on('hide', function() {
            	if ($('#checkInMovilHotel').hasClass('datepicker-input-content-selected')) {
            		$('#checkInMovilHotel').removeClass('datepicker-input-content-selected');
            	}

            	if ($('#checkOutMovilHotel').hasClass('datepicker-input-content-selected')) {
            		$('#checkOutMovilHotel').removeClass('datepicker-input-content-selected');
            	}
            });

            $(element).on('changeDate', function(e) {
                if (e.target.id == 'checkInHotel') {
                    
                    scope.$apply(function() {
                    	scope.checkInHotel = moment(e.target.value).format("YYYY-MM-DD");
                    	scope.checkOutHotel = moment(e.target.value).add(2, 'days').format("YYYY-MM-DD");
                    });
                    
                    var date = moment(e.target.value).format("YYYY-MM-DD");
                    var endDate = moment(e.target.value).add(29, 'days').format('YYYY-MM-DD');

                    $(".checkOutHotel").datepicker({
                        format: "yyyy-mm-dd",
                        todayBtn: "linked",
                        language: $("#langInput").val(),
                        orientation: "auto"
                    });

                    $(".checkOutHotel").datepicker("setStartDate", moment(date).add(1, 'days').format("YYYY-MM-DD"));
                    $(".checkOutHotel").datepicker('update', moment(date).add(2, 'days').format("YYYY-MM-DD"));
                    $(".checkOutHotel").datepicker('setEndDate', endDate);
                    $('.checkInHotel').datepicker('hide');
                    $('.checkOutHotel').datepicker('show');

                    if ($(window).width() < 576) {
                        $("#checkOutMovilHotel").trigger("click");
                    }
                    //se asigna valor al datepicker general
                    $('#checkIn').val( $('.checkInHotel').val() );
                    $('#checkOut').val( $('.checkOutHotel').val() );
                }

                if (e.target.id == 'checkOutHotel') {
                    if ($('.checkOutHotel').val() != "") {
                        $('.checkOutHotel').datepicker("hide");
                    }

                    scope.$apply(function() {
                    	scope.checkOutHotel = moment(e.target.value).format("YYYY-MM-DD");
                    });
                    //se asigna valor al datepicker general
                    $('#checkOut').val( $('.checkOutHotel').val() );
                }
            });
        }
    }
})();